module.exports = __webpack_public_path__ + "static/media/white.b0f9add3.svg";